<div id="sidebar-collapse" class="sidebar" [class.mobile-open]="Portal_main.isMobileSidebarOpen"
  style="overflow: auto;height: 100vh; width:100%; position: relative; flex: 0 0 100%;">

  <div class="admin-block d-flex" style="align-items: center; position: sticky;top:0;z-index: 999; background: #226CE0">
    <div>
      <img [src]="Portal_main.accountImageUrl" class="logo_nav" style="border-radius: 10px;" />
    </div>
    <!-- <div class="mobile-close-btn-container">
    <button class="mobile-close-btn" (click)="closeMobileSidebar()">
      <mat-icon>close</mat-icon>
    </button></div> -->
    <!-- <button class="toggle-btn" (click)="isCollapsed = !isCollapsed" style="margin-left: auto; background: none; border: none; color: white; cursor: pointer;">
  <mat-icon>{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button> -->
  </div>
  <ul class="side-menu metismenu">
    <div class="sidebar-wrapper">
      <li>
        <a routerLinkActive="active" routerLink="/sdp/operator/dashboard" [hidden]="sidebar['Operator Dashboard']"
          class="sidebar-link">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            class="sidebar-icon">
            <path d="M8 10L8 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M12 12V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 8V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2" />
          </svg>
          <span class="nav-label"> {{ translation.t('sidebar', 'operatorDashboard') }} </span>
        </a>
      </li>
    </div>
    <div class="sidebar-wrapper">
      <li>
        <a routerLinkActive="active" routerLink="/sdp/officer/dashboard" [hidden]="sidebar['Officer Dashboard']"
          class="sidebar-link">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            class="sidebar-icon">
            <path d="M8 10L8 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M12 12V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 8V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2" />
          </svg>
          <span class="nav-label">{{ translation.t('sidebar', 'officerDashboard') }}</span>
        </a>
      </li>
    </div>
    <div class="sidebar-wrapper">
      <li>
        <a routerLinkActive="active" routerLink="/sdp/admin/dashboard" [hidden]="sidebar['Admin Dashboard']"
          class="sidebar-link">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            class="sidebar-icon">
            <path d="M8 10L8 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M12 12V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 8V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2" />
          </svg>
          <span class="nav-label">{{ translation.t('sidebar', 'adminDashboard') }}</span>
        </a>
      </li>
    </div>

    <div class="sidebar-wrapper">
      <li>
        <a routerLinkActive="active" class="sidebar-link" routerLink="/sdp/mc/dashboard"
          [hidden]="sidebar['Municipal Commissinor Dashboard']">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            class="sidebar-icon">
            <path d="M8 10L8 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M12 12V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 8V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2" />
          </svg>
          <span class="nav-label"> {{ translation.t('sidebar', 'mcDashboard') }} </span>
        </a>
      </li>
      <div class="sidebar-wrapper">
        <li>
          <a routerLinkActive="active" class="sidebar-link" routerLink="/sdp/mc/total-greviance"
            [hidden]="sidebar['Total Greviance']">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              class="sidebar-icon">
              <path d="M8 10L8 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M12 12V16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M16 8V16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2" />
            </svg>
            <span class="nav-label"> {{ translation.t('sidebar', 'totalGrievance') }} </span>
          </a>
        </li>
      </div>
      <div class="sidebar-wrapper">

        <li>
          <a routerLinkActive="active" class="sidebar-link" routerLink="/sdp/mc/today-greviance"
            [hidden]="sidebar['Today Greviance']">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              class="sidebar-icon">
              <path d="M8 10L8 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M12 12V16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M16 8V16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2" />
            </svg>
            <span class="nav-label"> {{ translation.t('sidebar', 'todayGrievance') }} </span>
          </a>
        </li>
      </div>
      <div class="sidebar-wrapper">

        <li>
          <a routerLinkActive="active" class="sidebar-link" routerLink="/sdp/mc/pending-mc"
            [hidden]="sidebar['Pending MC']">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              class="sidebar-icon">
              <path d="M8 10L8 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M12 12V16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M16 8V16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2" />
            </svg>
            <span class="nav-label"> {{ translation.t('sidebar', 'pendingComp') }}</span>
          </a>
        </li>
      </div>

      <div class="sidebar-wrapper">
        <li>
          <a routerLinkActive="active" routerLink="/sdp/operator/new-compliants" [hidden]="sidebar['New Complaints']"
            class="sidebar-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              class="sidebar-icon">
              <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" />
              <path d="M12 15L12 9" stroke="currentColor" stroke-width="2" stroke-linecap="square" />
              <path d="M15 12L9 12" stroke="currentColor" stroke-width="2" stroke-linecap="square" />
            </svg>
            <span class="nav-label"> {{ translation.t('sidebar', 'newComplaints') }} </span>
          </a>
        </li>
      </div>
      <div class="sidebar-wrapper">
        <li>
          <a routerLinkActive="active" routerLink="/sdp/operator/compliants" [hidden]="sidebar['Complaints']"
            class="sidebar-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              class="sidebar-icon">
              <path
                d="M15.2002 5V4V5ZM18.3623 5.32715L18.8164 4.4362L18.8163 4.43614L18.3623 5.32715ZM19.6729 6.6377L20.5639 6.18371L20.5638 6.18359L19.6729 6.6377ZM20 9.7998H21H20ZM20 12.2002H21H20ZM19.6729 15.3623L20.5638 15.8164L20.5639 15.8163L19.6729 15.3623ZM18.3623 16.6729L18.8163 17.5639L18.8164 17.5638L18.3623 16.6729ZM15.2002 17V18V17ZM4.76855 20.2314L4.06145 19.5243H4.06145L4.76855 20.2314ZM4 19.9141H3L3 19.915L4 19.9141ZM4 9.7998H3H4ZM4.32715 6.6377L3.4362 6.18359L3.43614 6.1837L4.32715 6.6377ZM5.6377 5.32715L5.1837 4.43614L5.18359 4.4362L5.6377 5.32715ZM8.7998 5V4V5ZM7.70711 17.2929L7 16.5858L7.70711 17.2929ZM15.2002 5V6C16.0566 6 16.639 6.00082 17.0891 6.03763C17.5276 6.07349 17.7519 6.13845 17.9083 6.21816L18.3623 5.32715L18.8163 4.43614C18.331 4.18887 17.8143 4.09026 17.2521 4.04429C16.7016 3.99927 16.0238 4 15.2002 4V5ZM18.3623 5.32715L17.9082 6.2181C18.2844 6.40981 18.5902 6.71565 18.7819 7.0918L19.6729 6.6377L20.5638 6.18359C20.1804 5.4313 19.5687 4.81963 18.8164 4.4362L18.3623 5.32715ZM19.6729 6.6377L18.7818 7.09169C18.8615 7.24811 18.9265 7.47241 18.9624 7.91089C18.9992 8.361 19 8.94335 19 9.7998H20H21C21 8.97623 21.0007 8.29838 20.9557 7.74787C20.9097 7.18573 20.8111 6.66899 20.5639 6.18371L19.6729 6.6377ZM20 9.7998H19V12.2002H20H21V9.7998H20ZM20 12.2002H19C19 13.0566 18.9992 13.639 18.9624 14.0891C18.9265 14.5276 18.8615 14.7519 18.7818 14.9083L19.6729 15.3623L20.5639 15.8163C20.8111 15.331 20.9097 14.8143 20.9557 14.2521C21.0007 13.7016 21 13.0238 21 12.2002H20ZM19.6729 15.3623L18.7819 14.9082C18.5902 15.2844 18.2844 15.5902 17.9082 15.7819L18.3623 16.6729L18.8164 17.5638C19.5687 17.1804 20.1804 16.5687 20.5638 15.8164L19.6729 15.3623ZM18.3623 16.6729L17.9083 15.7818C17.7519 15.8615 17.5276 15.9265 17.0891 15.9624C16.639 15.9992 16.0566 16 15.2002 16V17V18C16.0238 18 16.7016 18.0007 17.2521 17.9557C17.8143 17.9097 18.331 17.8111 18.8163 17.5639L18.3623 16.6729ZM15.2002 17V16H8.41421V17V18H15.2002V17ZM7.70711 17.2929L7 16.5858L4.06145 19.5243L4.76855 20.2314L5.47566 19.5243L5.47566 19.5243L7.70711 17.2929ZM5 19.9141V17.0002H3V19.9141H5ZM4 19.915L4.00042 19.915L4.00042 17.915L4 17.915L4 19.915ZM5 12.0002V7.0002H3V12.0002H5ZM5.22896 6.1837L5.1837 6.1837L5.1837 4.1837L5.22896 4.1837L5.22896 6.1837ZM5.18359 4.4362L4.32715 6.6377L6.19424 7.36379L7.05069 5.16229L5.18359 4.4362ZM5.1837 4.1837C4.79373 4.1837 4.47167 4.2952 4.23838 4.54407C4.01578 4.78151 3.90981 5.10915 3.90981 5.39174L5.90981 5.39174C5.90981 5.39265 5.90956 5.3992 5.91811 5.43828C5.92244 5.4581 5.93291 5.50085 5.96825 5.53854C6.01429 5.58765 6.09575 5.66692 6.36881 5.77312L5.64278 7.63979C6.4632 7.95892 7.32922 7.82862 7.90483 7.21466C8.47174 6.60991 8.63666 5.82392 8.52846 5.16117C8.42589 4.53289 8.08253 4.1837 7.7998 4.1837H5.1837ZM6.09169 5.2329L5.6377 5.32715L5.22896 4.1837L4.76855 3.96145L6.09169 5.2329ZM8.7998 5C8.7998 5.82358 8.12726 6.5002 7.2998 6.5002V8.5002C9.22956 8.5002 10.7998 6.93514 10.7998 5H8.7998ZM7.2998 6.5002C6.4764 6.5002 5.80809 5.82766 5.80809 5.00427H3.80809C3.80809 6.92985 5.36785 8.5002 7.2998 8.5002V6.5002ZM5.80809 5.00427C5.80809 4.17681 6.48063 3.50427 7.30809 3.50427V1.50427C5.37207 1.50427 3.80809 3.07682 3.80809 5.00427H5.80809ZM7.30809 3.50427C8.13148 3.50427 8.7998 4.17258 8.7998 5H10.7998C10.7998 3.07259 9.23921 1.50427 7.30809 1.50427V3.50427ZM12.0002 12C12.0002 12.8236 11.3277 13.5002 10.5002 13.5002V15.5002C12.4299 15.5002 14.0002 13.9351 14.0002 12H12.0002ZM10.5002 13.5002C9.6768 13.5002 9.00849 12.8277 9.00849 12.0043H7.00849C7.00849 13.9298 8.56825 15.5002 10.5002 15.5002V13.5002ZM9.00849 12.0043C9.00849 11.1768 9.68103 10.5043 10.5085 10.5043V8.50427C8.57247 8.50427 7.00849 10.0768 7.00849 12.0043H9.00849ZM10.5085 10.5043C11.3319 10.5043 12.0002 11.1726 12.0002 12H14.0002C14.0002 10.0726 12.4396 8.50427 10.5085 8.50427V10.5043Z"
                fill="currentColor" />
              <path d="M8 9L16 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M8 13L13 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span class="nav-label"> {{ translation.t('sidebar', 'complaints') }} </span>
          </a>
        </li>
      </div>
      <div class="sidebar-wrapper">
        <li>
          <a routerLinkActive="active" routerLink="officer/pending-complaints" [hidden]="sidebar['Pending Complaints']"
            class="sidebar-link"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
              fill="none" class="sidebar-icon">
              <path
                d="M9.14939 7.8313C8.57654 5.92179 10.0064 4 12 4V4C13.9936 4 15.4235 5.92179 14.8506 7.8313L13.2873 13.0422C13.2171 13.2762 13.182 13.3932 13.128 13.4895C12.989 13.7371 12.7513 13.9139 12.4743 13.9759C12.3664 14 12.2443 14 12 14V14C11.7557 14 11.6336 14 11.5257 13.9759C11.2487 13.9139 11.011 13.7371 10.872 13.4895C10.818 13.3932 10.7829 13.2762 10.7127 13.0422L9.14939 7.8313Z"
                stroke="currentColor" stroke-width="2" />
              <circle cx="12" cy="19" r="2" stroke="currentColor" stroke-width="2" />
            </svg>
            <span class="nav-label">{{ translation.t('sidebar', 'pendingComp') }} </span>
          </a>
        </li>
      </div>
      <div class="sidebar-wrapper">
        <li>
          <a routerLinkActive="active" routerLink="officer/resolved-complaints"
            [hidden]="sidebar['Resolved Complaints']" class="sidebar-link"><svg xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" viewBox="0 0 24 24" fill="none" class="sidebar-icon">
              <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" />
              <path d="M8 12L11 15L16 9" stroke="currentColor" stroke-width="2" />
            </svg>
            <span class="nav-label"> {{ translation.t('sidebar', 'resolvedComp') }} </span>
          </a>
        </li>
      </div>
      <div class="sidebar-wrapper">
        <!-- <li>
          <a routerLinkActive="active" routerLink="officer/closed-complaints" [hidden]="sidebar['Search Complaints']"
            class="sidebar-link"><span class="sidebar-icon"><mat-icon>lock</mat-icon></span>
            <span class="nav-label"> {{ translation.t('sidebar', 'closedComp') }} </span>
          </a>
        </li> -->
      </div>

      <div class="sidebar-wrapper">
        <li>
          <a routerLinkActive="active" routerLink="officer/escalated-complaints" [hidden]="sidebar['Search Complaints']"
            class="sidebar-link"><span class="sidebar-icon"><mat-icon>warning</mat-icon></span>
            <span class="nav-label"> {{ translation.t('sidebar', 'escalatedComplaints') }} </span>
          </a>
        </li>
      </div>

    </div>






    <div class="sidebar-wrapper">
      <li>
        <a routerLinkActive="active" class="sidebar-link" routerLink="admin/user-management"
          [hidden]="sidebar['User Management']"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
            viewBox="0 0 24 24" fill="none" class="sidebar-icon">
            <path
              d="M17.7956 20.7059C17.4537 19.6427 16.7004 18.7033 15.6526 18.0332C14.6047 17.3632 13.3208 17 12 17C10.6792 17 9.3953 17.3632 8.34743 18.0332C7.29957 18.7033 6.5463 19.6427 6.20445 20.7059"
              stroke="currentColor" stroke-width="2" />
            <circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" stroke-width="2" />
          </svg>
          <span class="nav-label"> {{ translation.t('sidebar', 'userManagement') }}</span>
        </a>
      </li>
    </div>
    <div class="sidebar-wrapper">
      <li>
        <a routerLinkActive="active" class="sidebar-link" routerLink="admin/dep-management"
          [hidden]="sidebar['Department Management']"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
            viewBox="0 0 24 24" fill="none" class="sidebar-icon">
            <ellipse cx="12" cy="7" rx="7" ry="3" stroke="currentColor" stroke-width="2" />
            <path
              d="M5 13C5 13 5 15.3431 5 17C5 18.6569 8.13401 20 12 20C15.866 20 19 18.6569 19 17C19 16.173 19 13 19 13"
              stroke="currentColor" stroke-width="2" stroke-linecap="square" />
            <path d="M5 7C5 7 5 10.3431 5 12C5 13.6569 8.13401 15 12 15C15.866 15 19 13.6569 19 12C19 11.173 19 7 19 7"
              stroke="currentColor" stroke-width="2" />
          </svg>
          <span class="nav-label"> {{ translation.t('sidebar', 'depManagement') }}</span>
        </a>
      </li>
    </div>
    <div class="sidebar-wrapper">
      <li>
        <a routerLinkActive="active" class="sidebar-link" routerLink="admin/escalation-matrix"
          [hidden]="sidebar['Escalation Matrix']"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
            viewBox="0 0 24 24" fill="none" class="sidebar-icon">
            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" />
            <path d="M16.5 12H12.25C12.1119 12 12 11.8881 12 11.75V8.5" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" />
          </svg>
          <span class="nav-label"> {{ translation.t('sidebar', 'escalationMatrix') }} </span>
        </a>
      </li>
    </div>
    <div class="sidebar-wrapper">
      <li>
        <a routerLinkActive="active" class="sidebar-link" routerLink="admin/zone-word-mapping"
          [hidden]="sidebar['Zone & Word Mapping']"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
            viewBox="0 0 24 24" fill="none" class="sidebar-icon">
            <path
              d="M21 16.6953V5.66466C21 5.34631 20.6785 5.12861 20.3829 5.24685L16.1351 6.94596C16.0473 6.98109 15.9506 6.98765 15.8588 6.96471L8.14116 5.03529C8.04939 5.01235 7.95273 5.01891 7.8649 5.05404L3.28287 6.88685C3.11203 6.95519 3 7.12066 3 7.30466V18.3353C3 18.6537 3.32154 18.8714 3.61713 18.7531L7.8649 17.054C7.95273 17.0189 8.04939 17.0123 8.14117 17.0353L15.8588 18.9647C15.9506 18.9877 16.0473 18.9811 16.1351 18.946L20.7171 17.1131C20.888 17.0448 21 16.8793 21 16.6953Z"
              stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
            <path d="M16 19V7" stroke="currentColor" stroke-width="2" />
            <path d="M8 17L8 5" stroke="currentColor" stroke-width="2" />
          </svg>
          <span class="nav-label" style="font-size: 15px;"> {{ translation.t('sidebar', 'zoneWordMapping') }}</span>
        </a>
      </li>
    </div>
    <div class="sidebar-wrapper">
      <li>
        <a routerLinkActive="active" class="sidebar-link" routerLink="/portal/acc"
          [hidden]="sidebar['Portal Profile']"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
            viewBox="0 0 24 24" fill="none" class="sidebar-icon">
            <path
              d="M21 16.6953V5.66466C21 5.34631 20.6785 5.12861 20.3829 5.24685L16.1351 6.94596C16.0473 6.98109 15.9506 6.98765 15.8588 6.96471L8.14116 5.03529C8.04939 5.01235 7.95273 5.01891 7.8649 5.05404L3.28287 6.88685C3.11203 6.95519 3 7.12066 3 7.30466V18.3353C3 18.6537 3.32154 18.8714 3.61713 18.7531L7.8649 17.054C7.95273 17.0189 8.04939 17.0123 8.14117 17.0353L15.8588 18.9647C15.9506 18.9877 16.0473 18.9811 16.1351 18.946L20.7171 17.1131C20.888 17.0448 21 16.8793 21 16.6953Z"
              stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
            <path d="M16 19V7" stroke="currentColor" stroke-width="2" />
            <path d="M8 17L8 5" stroke="currentColor" stroke-width="2" />
          </svg>
          <span class="nav-label" style="font-size: 15px;"> {{ translation.t('header', 'profile') }}</span>
        </a>
      </li>
    </div>

    <div class="sidebar-wrapper">
      <li>
        <a routerLinkActive="active" class="sidebar-link" routerLink="admin/hier" [hidden]="sidebar['Hier']">
          <i class="fa fa-sitemap sidebar-icon" style="font-size: 20px;"></i>
          <span class="nav-label" style="font-size: 15px;"> {{ translation.t('sidebar', 'hierarchy') }}</span>
        </a>
      </li>
    </div>


    <div class="sidebar-wrapper">
      <li>
        <a [hidden]="sidebar['Role']" routerLinkActive="active" class="sidebar-link" routerLink="admin/role"><i
            class="sidebar-item-icon fa fa-users sidebar-icon"></i>

          <span class="nav-label"> {{ translation.t('sidebar', 'roleManagement') }}</span>
        </a>
      </li>
    </div>
    <!-- <li>
      <a routerLinkActive="active"  class="sidebar-link"  routerLink="admin/hier" ><i class="fa fa-sitemap"></i>
        <span class="nav-label"> Hierarchy</span>
      </a>
    </li> -->

    <!-- <li >
        <a  routerLinkActive="active" routerLink="/cfc/cfc-content"><i class="sidebar-item-icon fa fa-th-large"></i>
          <span class="nav-label"> Content </span>
        </a>
      </li> -->
    <!-- <li >
        <a  routerLinkActive="active" routerLink="/cfc/cfc-admin"><i class="sidebar-item-icon fa fa-th-large"></i>
          <span class="nav-label"> Admin</span>
        </a>
      </li> -->
    <!-- <li >
        <a  routerLinkActive="active" routerLink="/cfc/cfc-usermanagement"><i class="sidebar-item-icon fa fa-th-large"></i>
          <span class="nav-label"> User Management</span>
        </a>
      </li> -->
    <!-- <li >
        <a  routerLinkActive="active" routerLink="/cfc/cfc-department"><i class="sidebar-item-icon fa fa-th-large"></i>
          <span class="nav-label"> Department Management</span>
        </a>
      </li> -->
    <!-- <li >
        <a  routerLinkActive="active" routerLink="/cfc/cfc-escalation"><i class="sidebar-item-icon fa fa-th-large"></i>
          <span class="nav-label"> Escalation Matrix</span>
        </a>
      </li> -->
    <!-- <li >
        <a  routerLinkActive="active" routerLink="/cfc/cfc-zonesetup"><i class="sidebar-item-icon fa fa-th-large"></i>
          <span class="nav-label"> Zone & Setup</span>
        </a>
      </li> -->
    <!-- <li routerLinkActive="active" [hidden]="sidebar['administration']">
      <a class="text-decoration-none" href="#" data-toggle="collapse" data-target="#collapseAdmin" aria-expanded="false"
        aria-controls="collapseAdmin" [hidden]="sidebar['administration']"><i
          class="sidebar-item-icon fa fa-database"></i>
        <span class="nav-label">Administration</span><i class="fa fa-angle-left arrow"></i></a>
      <ul class="nav-2-level collapse" id="collapseAdmin" data-parent="#sidebar-collapse">
        <div id="adminParent">
          <li [hidden]="sidebar['master_data']">
            <a class="text-decoration-none" href="#" data-toggle="collapse" data-target="#set" aria-expanded="false"
              aria-controls="set" [hidden]="sidebar['master_data']">
              <span class="nav-label">Master Data</span><i class="fa fa-angle-left arrow"></i></a>

            <ul class="nav-3-level collapse" id="set" data-parent="#adminParent">

              <li [hidden]="sidebar['code_value']">
                <a (click)="Screen('Code Value')" routerLink="/cfc/administration/code-value"
                  routerLinkActive="active">Code Value</a>
              </li>
              <li [hidden]="sidebar['field']">
                <a routerLink="/cfc/administration/field" (click)="Screen('Field')" routerLinkActive="active">Field</a>
              </li>

              <li [hidden]="sidebar['hierarchy']">
                <a routerLink="/cfc/administration/hierarchy" (click)="Screen('Hierarchy')"
                  routerLinkActive="active">Hierarchy</a>
              </li>

            </ul>


          </li>
          <li [hidden]="sidebar['security']">
            <a lass="text-decoration-none" href="#" data-toggle="collapse" data-target="#sec" aria-expanded="false"
              aria-controls="sec" [hidden]="sidebar['security']" [hidden]="sidebar['security']">
              <span class="nav-label">Security</span><i class="fa fa-angle-left arrow"></i></a>
            <ul class="nav-3-level collapse" id="sec" data-parent="#adminParent">
              <li [hidden]="sidebar['role']">
                <a [hidden]="sidebar['role']" (click)="Screen('Add Employee')" routerLink="/cfc/administration/add-emp"
                  routerLinkActive="active">
                  Add Employee
                </a>
              </li>
              <li [hidden]="sidebar['role']">
                <a [hidden]="sidebar['role']" (click)="Screen('Role')" routerLink="/cfc/administration/roles"
                  routerLinkActive="active">
                  Role
                </a>
              </li>
              <li>
                <a [hidden]="sidebar['user']" routerLink="/cfc/administration/users" (click)="Screen('User')"
                  routerLinkActive="active">User</a>
              </li>
              <li [hidden]="sidebar['work_assignment']">
                <a routerLink="/cfc/administration/work-assignment" routerLinkActive="active"
                  (click)="Screen('Work Assignment')">Work Assignment</a>
              </li>
              <li [hidden]="sidebar['service_assignment']">
                <a routerLink="/cfc/administration/service-assignment" routerLinkActive="active"
                  (click)="Screen('Service Assignment')">Service Assignment</a>
              </li>
              <li [hidden]="sidebar['area_mapping']">
                <a routerLink="/cfc/administration/area-mapping" routerLinkActive="active"
                  (click)="Screen('Zone Mapping')">Zone Mapping</a>
              </li>
              <li [hidden]="sidebar['payment_map']">
                <a routerLink="/cfc/administration/payment-map" routerLinkActive="active"
                  (click)="Screen('Payment Maping')">Payment Maping</a>
              </li>

              <li>
                <a [hidden]="sidebar['workflow']" routerLink="/cfc/administration/workflow" (click)="Screen('Workflow')"
                  routerLinkActive="active">Workflow</a>
              </li>
            </ul>
          </li>
          <li [hidden]="sidebar['verifier']">
            <a routerLink="/cfc/administration/verifier" (click)="Screen('Verifier')" class="text-decoration-none">
              <i class="sidebar-item-icon fa fa-check-circle"></i>
              <span class="nav-label">Verifier</span>
            </a>
          </li>
          <li [hidden]="sidebar['Data-Entry-Dashboard']">
            <a routerLink="/cfc/administration/Data-Entry-Dashboard" (click)="Screen('Data-Entry-Dashboard')"
              class="text-decoration-none">
              <i class="sidebar-item-icon fa fa-check-circle"></i>
              <span class="nav-label">Data-Entry-Dashboard</span>
            </a> 
          </li>
        </div>
      </ul>
      </li> -->

    <div class="sidebar-wrapper" style="position: absolute; align-items: center; bottom: 30px !important; ">
      <li class="dropdown dropdown-user">
        <div class="nav-item full-screen">
          <a class="nav-link check dropdown-toggle link nav-item text-center"
            style="display: block;padding-left: 10px;bottom:0px;" data-toggle="dropdown">
            <img [src]="Portal_main.profileImageUrl" style="border-radius: 10px;" width="35px" height="35px" />
            <span class=" r-font-s profile-wrap font-weight-bold text-white ml-2" style="display: block;"
              *ngIf="erpUser">
              <!-- {{erpUser['designation']}} -->
              {{erpUser['party_name']}} </span>
            <span class="r-font-s text-white ml-2" *ngIf="erpUser" style="display:block; margin:0; line-height:1;">
              ( {{erpUser['role_cd']}} )
            </span></a>
          <div class="sidebar-wrapper sidebar-lang-toggle ">
            <div class="d-flex justify-content-center" style="padding: 8px 14px;">
              <div class="toggle-circle"
                [ngClass]="{'hin-active': auth.language_cd === 'HIN', 'eng-active': auth.language_cd === 'ENG'}"
                (click)="toggleLanguage()"
                style="cursor: pointer; width: fit-content; border-radius: 20px; padding: 6px 18px; height: auto;">
                {{ auth.language_cd === 'HIN' ? 'हिन्दी' : 'Eng' }}
              </div>
            </div>
          </div>
          <!-- <span class=" r-font-s   text-white ml-2" *ngIf="erpUser">( {{roles}}
              )</span> -->
          <i class="fa fa-angle-down m-l-5 m-s-1 font-weight-bold text-white"></i>
          <ul class="dropdown-menu dropdown-menu-left ">
            <a class="dropdown-item " [routerLink]="['/sdp/UserProfileComponent']"
              routerLinkActive="router-link-active"><i class="fa fa-user"></i>{{ translation.t('header', 'profile')
              }}</a>
            <!-- <a  class="dropdown-item" *ngIf="erpUser?.role_cd?.includes('Admin')" [routerLink]="['/portal/acc']"
              routerLinkActive="router-link-active"><i class="fa fa-user-plus"></i>Portal Profile</a> -->
            <a class="dropdown-item" (click)="logOut()" routerLinkActive="router-link-active"><i
                class="fa fa-power-off"></i>{{ translation.t('header', 'logout') }}</a>
          </ul>
        </div>
      </li>
    </div>
    <!-- Language Toggle: only below 576px -->

  </ul>
</div>